import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Button from '../../components/Button'
import TextInput from '../../components/TextInput'
import Card from '../../components/Card'
import Spinner from '../../components/Spinner'
import * as actionCreators from '../../root/actions'
import { ACTIVATION_URL } from '../../api/endpoints'

export class Activation extends Component {
  constructor(props) {
    super(props)
  }

  state = {
    activationCode: '',
    isSubmitting: false
  }

  render() {
    const { onSubmit, renderView } = this
    const { app } = this.props.containers

    return (
      <Card>
        <form onSubmit={onSubmit} className="activation-form mobile-padding">
          {this.props.api.get('isLoading') && app.get('isMobile') ? (
            <Spinner />
          ) : (
            renderView()
          )}
        </form>
      </Card>
    )
  }

  renderView = () => {
    const { api, containers } = this.props
    const { app } = containers

    return (
      <Fragment>
        <div>
          <span className="medium-weight">Welcome</span>
        </div>
        <span className="main-message light-weight">
          You have received a private activation code via the e-mail address you
          provided. Please check your email and enter it below to proceed.
        </span>
        <br />
        <br />
        {!api.get('isLoading') && (
          <TextInput
            autoFocus
            className="underlineText"
            style={{ fontSize: '26px' }}
            onChange={({ target }) =>
              this.setState({ activationCode: target.value })
            }
            placeholder="Activation Code"
          />
        )}
        <br />
        {api.get('isLoading') ? (
          <Spinner />
        ) : (
          <div>
            <Button
              fullWidth
              disabled={api.get('isLoading') || !this.state.activationCode}
              type="submit"
              fixed
            >
              Submit
            </Button>
          </div>
        )}
        {/* {!app.get('isMobile') && (
          <Fragment>
            <br />
            <br />
          </Fragment>
        )}
        <h6 id="activation-footnote" className="footnote">
          *Lab100 is currently in private beta mode with limited appointment
          slots available. If you are reading this, you have already been added
          to our waitlist. Stay tuned and thank you for your interest!
        </h6> */}
      </Fragment>
    )
  }

  onSubmit = e => {
    e.preventDefault()
    const { activationCode } = this.state

    if (this.state.isSubmitting || activationCode === '') return
    this.setState({ isSubmitting: true })
    const { apiRequest, changeRoute, getUserFromDBAndUpdateStore } = this.props

    const request = {
      url: ACTIVATION_URL,
      data: { activationCode },
      method: 'post'
    }

    const meta = {
      onError: () => this.setState({ isSubmitting: false }),
      onSuccess: () => {
        getUserFromDBAndUpdateStore({
          onError: () => this.setState({ isSubmitting: false }),
          onSuccess: () => {
            this.setState({ isSubmitting: false }, () =>
              changeRoute({ route: '/upcoming/schedule' })
            )
          }
        })
      }
    }

    apiRequest(request, meta)
  }
}

const mapStateToProps = state => {
  const { containers, api } = state

  return {
    containers,
    api
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Activation)
